<template lang="pug">
div
	v-e24-nav-bar
	SectionTitle(isAccordions='true' :srcImage='imgHeader', :tall="tall", h1="Order Receipt")
	section.maincolumn
		.app-page(v-if="dataReady")
			.main-container
				.child-container.recipt-wrap
					h3 Thanks for using EasyTitle24.com!
					p
						b If you are done for now, 	and for the security of your account, you may want to &nbsp;
						login-button

					invoice-detail(:products="order.items",
									:subtotal="subtotal",
									:taxAmount="taxAmount",
									:total="total")

					h3 Payment Information

					credit-card(:card="card")

					contacts-block(:contacts="contacts")

					//- p
					//- 	h3 EasyTitle24.com
					//- 	br
					//- 	| 654 Oakland Av.
					//- 	br
					//- 	| Oakland
					//- 	br
					//- 	| 94611
					//- 	br
					//- 	| CA, USA

		v-e24-footer(:build="build")
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import { mapState } from 'vuex'
import moment from 'moment'
import store from 'CommonApp/store'
import imageHeader from '@/common/img/list-project.jpg'
import SectionTitle from '@/common/components/sectionTitle.vue'
import readBuild from '../../util/readBuild'

export default {
	name: 'receipt',
	data () {
		return {
			build: '',
			dataReady: false,
			query: {},
			order: null,
			card: null,
			contacts: [],
			imgHeader: imageHeader,
			tall: 90
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	components: { SectionTitle },
	methods: {
		async init () {
			if (!_.isNil(this.query['ssl_result']) && this.query['ssl_result'] === '0') {
				// Find order and update
				Vue.e24.orderService.findOrderById(this.query['ssl_invoice_number']).then((orderFound) => {
					if (!_.isNil(orderFound)) {
						this.order = orderFound
						// Update order status and payment
						const expDate = this.query['ssl_exp_date']

						Vue.e24.contactService.findContactByProjIdAndType(orderFound.projId, 'BO').then((billingContact) => {
							this.contacts.push({title: 'Billing contact', object: billingContact})
							if (_.isNil(orderFound.payment) || _.isNil(orderFound.payment.approvalCode)) {
								orderFound.payment = {
									payorName: this.query['ssl_first_name'] + ' ' + this.query['ssl_last_name'],
									number: this.query['ssl_card_number'],
									expire: moment().year(20 + expDate[2] + expDate[3]).month(expDate[0] + expDate[1]).startOf('month').toDate(),
									approvalCode: this.query['ssl_approval_code'],
									methodCode: 'UNKNOWN', // TODO: add card type, by this moment the response doesn't contain card type
									response: this.query, // Save entire response object
									date: new Date()
								}
								console.log('Adding Payment', orderFound.payment)
								Vue.e24.orderService.setPayment(orderFound.orderId, orderFound.payment).then((orderUpdated) => {
									console.debug('orderUpdated', orderUpdated)
								})
							} else {
								// Show order not found error
								this.$notify({
									group: 'app',
									type: 'warning',
									title: 'Payment already registered',
									text: 'Did you reload the page? otherwise this shouldn\'t happen!',
									duration: -1
								})
							}
							// For display prurpouses only
							this.card = {
								nameOnCard: orderFound.payment.payorName,
								cardNumber: orderFound.payment.number,
								expireMonth: expDate[0] + expDate[1],
								expireYear: expDate[2] + expDate[3]
							}
							this.dataReady = true
						})
					} else {
						// Show order not found error
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Order not found',
							text: 'Requested order was not found ' + this.query['ssl_invoice_number'],
							duration: -1
						})
					}
				})
			} else {
				// Log error into order attempt record
				if (this.lastOrder && !_.isNil(this.query.errorCode)) {
					await Vue.e24.orderService.appendPaymentError(this.lastOrder, this.query)
				}

				if (this.activeProject) {
					Vue.e24.projectService.findOneById(this.activeProject).then((projectLoaded) => {
						// Redirect to checkout state and place on billing tab
						this.$router.push({
							name: 'checkout',
							params: {
								projId: projectLoaded.projId,
								isNewHome: projectLoaded.isNewHome,
								error: {
									code: this.query.errorCode,
									name: this.query.errorName,
									msg: this.query.errorMsg
								}
							}
						})
					})
				}
			}
		}
	},
	beforeRouteEnter: (to, from, next) => {
		if (Object.keys(to.query).length !== 0) {
			next(vm => {
				vm.query = to.query
				console.log('vm.query', vm.query)
			})
		}
		next(vm => {
			vm.init()
		})
	},
	beforeMount () {
		store.dispatch({
			type: 'initialiseStore',
			value: ''
		})
	},
	computed: {
		...mapState({
			activeProject: state => state.activeProject,
			lastOrder: state => state.lastOrder
		}),
		subtotal () {
			return (Math.round(this.order.orderSubtotal * 100) / 100).toFixed(2)
		},
		taxAmount () {
			return (Math.round(this.order.orderTax * 100) / 100).toFixed(2)
		},
		total () {
			const tot = parseFloat(this.order.orderTax) + parseFloat(this.order.orderSubtotal)
			return (Math.round(tot * 100) / 100).toFixed(2)
		}
	}
}
</script>

<style lang="less">
.recipt-wrap{
	width: 100%;
	padding: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/app/checkout/receipt.vue